



















































































import ConfirmModal from "@/components/ConfirmModal.vue";
import { Vue, Component, Mixins, Ref } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import { CatalogueSetting, catalogueSettings } from "../../models/Setting";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import { camelToUnderscore, capitalize } from "../../utils/Typography";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import BlueprintsMixin from "../../mixins/http/BlueprintsMixin";
import CreateModal from "@/components/Blueprint/Create.vue";
import EditModal from "@/components/Blueprint/Edit.vue";
import { showToast } from "../../utils/RailsRoutes";
import { httpStore } from "@/store/typed";
import Blueprint from "../../models/Blueprint";

@Component({
  components: {
    Page,
    DataTable,
    ConfirmModal,
    CreateModal,
    EditModal,
    Paginator,
  },
})
export default class ConfiguratorSettings extends Mixins(BlueprintsMixin) {
  items: Blueprint[] = [];

  mounted() {
    this.loadSetting();
  }

  get loading() {
    return this.indexRequest?.loading;
  }
  get columns() {
    const columns: Array<{ name: string; label: string }> = [];
    columns.push({ name: "name", label: "Nome" });
    columns.push({ name: "actions", label: "Actions" });
    columns.unshift({ name: "file", label: "File" });
    return columns;
  }

  get confirmModalName() {
    return `confirm_blueprint_deletion_modal`;
  }

  get createModalName() {
    return `create_blueprint_modal`;
  }

  get editModalName() {
    return `edit_blueprint_modal`;
  }

  destroyTag(value: CatalogueSetting) {
    return `destroy_blueprint_${value.id}_tag`;
  }

  get createTag() {
    return `create_blueprint_tag`;
  }

  updateTag(value: CatalogueSetting) {
    return `update_blueprint_${value.id}_tag`;
  }

  get settingTypes() {
    return [...catalogueSettings];
  }

  get indexTag() {
    return `get_blueprint_tag`;
  }

  get ratingSection() {
    return this.section === "catalogue_ratings";
  }

  get section(): string {
    return this.$route.params.section as string;
  }

  get settingType() {
    return this.settingTypes.find(
      (o) => camelToUnderscore(o.type) === this.section
    );
  }

  get confirmModalTitle() {
    return `Delete Blueprint`;
  }

  get createModal() {
    return this.$refs[this.createModalName] as any;
  }

  get editModal() {
    return this.$refs[this.editModalName] as any;
  }

  openCreateModal() {
    this.createModal.create();
  }

  async onDestroyClicked(value) {
    const confirmed = await (this.$refs[this.confirmModalName] as any).confirm(
      `Are you sure you want to delete this blueprint?`
    );
    const tag = this.destroyTag(value);
    if (confirmed) {
      this.destroyBlueprint(value.id, tag).then(
        (resp) => {
          this.items = this.items.filter((o) => o.id !== resp.id);
          showToast(`${value.labelEn || value.code} deleted successfully`);
        },
        (err) => {}
      );
    }
  }

  onEditClicked(value) {
    (this.$refs[this.editModalName] as any).edit(value);
  }

  onAdd(prototype) {
    this.items.unshift(prototype);
  }

  onEdit(value) {
    const index = this.items.findIndex((o) => o.id === value.id);
    Vue.set(this.items, index, value);
  }

  loadSetting(page = 1) {
    this.getBlueprints({ page: page }, this.indexTag).then(
      (resp) => {
        this.items = resp;
      },
      (err) => {}
    );
  }

  onPageChange(page) {
    this.loadSetting(page);
  }

  get indexRequest() {
    return httpStore.status[this.indexTag];
  }
}
